import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type standardToPremiumIncentiveOfferModalQuery,
} from './__generated__/standardToPremiumIncentiveOfferModalQuery.graphql';

export type EntryPointParams = {
	cloudId: string;
	hamsProductKey: string;
};

type StandardToPremiumIncentiveOfferModalComponent = EntryPointComponent<
	{ standardToPremiumIncentiveOfferModalQuery: standardToPremiumIncentiveOfferModalQuery },
	Record<string, never>,
	{ onClose: (extraInformation?: unknown) => void },
	Record<string, never>
>;

export const entryPoint: EntryPoint<
	StandardToPremiumIncentiveOfferModalComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<StandardToPremiumIncentiveOfferModalComponent>(
		/* webpackChunkName: "@atlaskit-internal_edition-awareness-standard-to-premium-incentive-offer-modal" */ './standard-to-premium-incentive-offer-modal',
		{
			moduleId: 'edition-awareness-standard-to-premium-incentive-offer-modal',
		},
	),
	getPreloadProps: ({ cloudId, hamsProductKey }: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			standardToPremiumIncentiveOfferModalQuery: {
				parameters,
				variables: { cloudId, hamsProductKey },
			},
		},
	}),
});
